<popup-sac
  [exibir]="exibePopupSac"
  (controleExibicao)="exibePopupSac = $event"
></popup-sac>
<div class="cs_modal" *ngIf="exibePopupUpload">
  <div>
    <span
      class="fa fa-times-circle cs_modal_close"
      (click)="fecharPopup()"
    ></span>
    <div class="cs_centralizado cs_modal__upload">
      <app-upload-files
        id="uploadFile"
        [imagem]="true"
        [imagemMembro]="true"
      ></app-upload-files>
    </div>
  </div>
</div>

<app-guide
  [exibirPopupPerfil]="exibirPopupGuide"
  [nome]="userName"
  (controleExibicao)="fecharPopupGuide()"
></app-guide>

<div class="manual">
  <img
    class="manual__icone"
    src="assets/images/icons/manual.png"
    (click)="abrirPopupGuide()"
  />
</div>

<div class="conteudo">
  <div class="apenas--mobile">
    <div class="perfil">
      <div class="perfil__carregando" *ngIf="carregandoPerfil">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            width: '4.5rem',
            height: '4.5rem',
            'margin-bottom': '8px'
          }"
          appearance="circle"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          count="2"
          [theme]="{
            width: '160px',
            height: '24px',
            'margin-bottom': '4px',
            display: 'block'
          }"
        ></ngx-skeleton-loader>
        <!-- <ngx-skeleton-loader
          count="1"
          [theme]="{
            width: '80px',
            height: '16px',
            'margin-top': '12px',
            display: 'block'
          }"
        ></ngx-skeleton-loader> -->
        <!-- <div class="loading__nivel">
          <div class="nivel__texto">
            <ngx-skeleton-loader
              count="3"
              [theme]="{
                'border-radius': '20px',
                height: '14px',
                'margin-bottom': '4px',
                width: '200px'
              }"
            ></ngx-skeleton-loader>
          </div>
          <ngx-skeleton-loader
            appearance="circle"
            count="1"
            [theme]="{
              width: '70px',
              height: '70px'
            }"
          ></ngx-skeleton-loader>
        </div> -->
      </div>
      <div *ngIf="!carregandoPerfil">
        <dynamic-form [fields]="regConfigDadosPessoa"></dynamic-form>
        <!-- <dynamic-form [fields]="regConfigBonusNivel"></dynamic-form> -->
      </div>
    </div>
    <div class="pontos">
      <app-pontos-expirar></app-pontos-expirar>
    </div>
    <!-- <div class="desafios">
      <dynamic-form [fields]="regConfigDesafios"></dynamic-form>
    </div> -->
    <div class="mobile__menu">
      <dynamic-form [fields]="regConfigCarouselVertical"></dynamic-form>
    </div>
  </div>
  <div class="apenas--desktop">
    <div class="desktop__menu">
      <!-- <div class="menu-item-desktop" *ngFor="let item of itensMenuCarousel" (click)="controleMenuPerfil(item)">
                <img class="menu-item-icone" [src]="item.imgIcon">
                <label class="cs_label menu-item-label">{{ item.label }}</label>
            </div> -->

      <!-- <div class="menu-item-desktop" (click)="controleMenuPerfil('/extrato')">
        <img src="assets/images/icons/extratos.png" class="menu-item-icone" />
        <label class="cs_label menu-item-label">Extrato de Cashback</label>
      </div> -->
      <div
        class="menu-item-desktop"
        (click)="controleMenuPerfil('/meuspedidos')"
      >
        <img src="assets/images/icons/pedidos.png" class="menu-item-icone" />
        <label class="cs_label menu-item-label">Meus pedidos</label>
      </div>
      <div
        class="menu-item-desktop"
        (click)="controleMenuPerfil('/atendimento', true)"
      >
        <img
          src="assets/images/icons/atendimento.png"
          class="menu-item-icone"
        />
        <label class="cs_label menu-item-label">Atendimento</label>
      </div>
      <div class="menu-item-desktop" (click)="controleMenuPerfil('/meusdados')">
        <img src="assets/images/icons/meus_dados.png" class="menu-item-icone" />
        <label class="cs_label menu-item-label">Meus dados</label>
      </div>
    </div>
  </div>
  <!-- <div class="beneficios">
    <app-beneficios-niveis
      *ngIf="idNivel != 0"
      [idNivel]="idNivel"
    ></app-beneficios-niveis>
  </div> -->
</div>
<!-- </div> -->
